import { enableMapSet } from "immer"
import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

type TPath = {
  title: string
  path: string
}

export type TNavActions = "trainings"

export type TBreadcrumbState = {
  previousPaths: TPath[]
  currentPath: TPath | null
  setCurrentPath: (path: TPath | null, previousPaths?: TPath[]) => void

  navActions?: TNavActions
  setNavActions: (actions: TNavActions) => void

  clearActions: () => void
}

enableMapSet()

export const useBreadcrumbs = create<
  TBreadcrumbState,
  [["zustand/immer", never]]
>(
  immer((set) => {
    return {
      currentPath: null,
      previousPaths: [],
      clearActions: () => {
        set((state) => {
          state.currentPath = null
          state.previousPaths = []
          state.navActions = undefined
        })
      },
      setCurrentPath: (path, previousPaths) => {
        set((state) => {
          state.currentPath = path
          state.previousPaths = previousPaths || []
          state.navActions = undefined
        })
      },
      navActions: undefined,
      setNavActions: (actions) => {
        set((state) => {
          state.navActions = actions
        })
      },
    }
  }),
)
